import { coverSortOrder } from '../../constants/application';
import { coverTypeSortOrder } from '../../constants/application';
/**
 * Order the applicant covers
 *
 * @param {Array} covers
 * @returns {Array}
 */
export const sortApplicantCovers = (covers, hideRiders) => {
  const coverRiders = [];
  const sortedCovers = covers
    .sort((a, b) => b.coverAmount - a.coverAmount)
    .sort(
      (a, b) =>
        coverTypeSortOrder.indexOf(a.coverType) -
        coverTypeSortOrder.indexOf(b.coverType)
    )
    .sort(
      (a, b) =>
        coverSortOrder.indexOf(a.productType.toLowerCase()) -
        coverSortOrder.indexOf(b.productType.toLowerCase())
    )
    .map((cover) => {
      if (cover.riders && cover.riders.length > 0 && !hideRiders) {
        coverRiders.push(...cover.riders);
      }
      return cover;
    });

  return [...sortedCovers, ...coverRiders];
};

/**
 * Replace any object properties with empty strings
 * with null
 *
 * @param {Object} obj
 * @returns {Object}
 */
export const setEmptyStringPropertiesToNull = (obj) =>
  Object.keys(obj).reduce((accumulator, key) => {
    if (obj[key] === '') {
      return { ...accumulator, [key]: null };
    }
    return { ...accumulator, [key]: obj[key] };
  }, {});

export const applyCoverErrors = (cover, errors) => {
  const error = errors.find((error) => error.attemptedValue.id === cover.id);
  if (error) {
    return {
      ...cover,
      errors: [error],
    };
  }
  return cover;
};
